import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {chain, RedirectToPunchOutSubmit} from "@insite/client-framework/Store/Pages/Cart/Handlers/DoPunchOutCheckout";

export interface PunchoutParameter {
    quoteNumber?: string;
}

type HandlerType = ApiHandler<PunchoutParameter, any>;

export const RedirectToPunchOutSubmitExtended: HandlerType = props => {
    if(props.parameter?.quoteNumber !== undefined){
        window.location.href = `/api/v1/punchOut/porequisition?quoteNumber=${props.parameter?.quoteNumber}`;
    }
    else{
        window.location.href = "/api/v1/punchOut/porequisition";
    }
};

replaceInChain(chain, RedirectToPunchOutSubmit, RedirectToPunchOutSubmitExtended);